// extracted by mini-css-extract-plugin
export var askAiIcon = "_nb-9";
export var container = "_nb-0";
export var groupSeparator = "_nb-a";
export var highlight = "_nb-4";
export var resultIcon = "_nb-5";
export var resultItem = "_nb-7";
export var resultSubtitle = "_nb-3";
export var resultTitle = "_nb-2";
export var resultsList = "_nb-1";
export var searchGroup = "_nb-6";
export var selected = "_nb-8";